import React from 'react';
import PropTypes from 'prop-types';
import LibraryRichText from 'rich-text-to-react';
import Heading from '@tds/core-heading';
import Paragraph from '@tds/core-paragraph';
import UnorderedList from '@tds/core-unordered-list';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';

const defaultOptions = {
  [BLOCKS.HEADING_1]: (node, key, next) => (
    <Heading key={key} level="h1">
      {next(node.content, key, next)}
    </Heading>
  ),
  [BLOCKS.HEADING_2]: (node, key, next) => (
    <Heading key={key} level="h2">
      {next(node.content, key, next)}
    </Heading>
  ),
  [BLOCKS.HEADING_3]: (node, key, next) => (
    <Heading key={key} level="h3">
      {next(node.content, key, next)}
    </Heading>
  ),
  [BLOCKS.HEADING_4]: (node, key, next) => (
    <Heading key={key} level="h4">
      {next(node.content, key, next)}
    </Heading>
  ),
  [BLOCKS.HEADING_5]: (node, key, next) => (
    <Heading key={key} level="h5">
      {next(node.content, key, next)}
    </Heading>
  ),
  [BLOCKS.HEADING_6]: (node, key, next) => (
    <h6
      style={{
        color: '#49166d'
      }}
    >
      {next(node.content, key, next)}
    </h6>
  ),
  [BLOCKS.PARAGRAPH]: (node, key, next) => (
    <Paragraph key={key} style={{ lineHeight: '1.5rem', marginBottom: '1em' }}>
      {next(node.content, key, next)}
    </Paragraph>
  ),
  [BLOCKS.UL_LIST]: (node, key, next) => (
    <UnorderedList key={key}>{next(node.content, key, next)}</UnorderedList>
  ),
  [BLOCKS.LIST_ITEM]: (node, key, next) => (
    <UnorderedList.Item key={key}>
      {next(node.content, key, next)}
    </UnorderedList.Item>
  ),
  [BLOCKS.EMBEDDED_ASSET]: node => {
    return (
      <>
        <img
          alt={node.data.target.fields.file.title}
          className="img-fluid"
          width={250}
          src={node.data.target.fields.file.url}
        />
      </>
    );
  }
};

const RichText = ({ data, options: { renderMark = {}, renderNode = {} } }) => {
  const mergedOptions = {
    renderMark: {
      ...renderMark,
      [MARKS.BOLD]: (text, key) => (
        <strong key={key} style={{ fontWeight: '900' }}>
          {text}
        </strong>
      )
    },
    renderNode: {
      ...defaultOptions,
      ...renderNode
    }
  };

  return data && <LibraryRichText document={data} options={mergedOptions} />;
};

RichText.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object)
  }),
  options: PropTypes.shape({
    renderMark: PropTypes.object,
    renderNode: PropTypes.object
  })
};

RichText.defaultProps = {
  data: null,
  options: {
    renderMark: {},
    renderNode: {}
  }
};
export default RichText;
